import React, { Fragment, useEffect } from "react";
import { Navigate, useSearchParams } from 'react-router-dom'
import { clearAuthToken } from "utils/auth";
import { SpinnerFullPage } from "shared/components/SpinnerFullPage";
import { accountService } from "inter-service/account";

export function Logout() {
  const [searchParams] = useSearchParams();
  clearAuthToken();
  useEffect(() => {
    const from = searchParams.get('from') || undefined;
    const logoutUrl = accountService.generateUrlToLogoutPage({ from, redirectAfterLogout: true });
    window.location.replace(logoutUrl);
  }, [searchParams]);
  return (
    <SpinnerFullPage />
  );
}

